export enum MENU_KEY {
  AiModel = 'ai-model',
  Marketplace = 'marketplace',
  Campaign = 'campaign',
  Feed = 'feed',
  Farming = 'farming',
  Leaderboard = 'leaderboard',
  Pricing = 'pricing',
  Attendance = 'attendance',
  NftAuthen = 'nft-authentication',
  AiTool = 'ai-tool',
  TeleBot = 'tele-bot',
  AiRight = 'ai-right',
}

export const MENU_LINK = {
  aiTool: 'https://airight.io/showcase',
  aiModel: 'https://airight.io/ai-model',
  marketplace: '/marketplace',
  campaign: '/campaign',
  feed: '/feed',
  farming: 'https://airight.io/farming',
  leaderboard: 'https://airight.io/leaderboard',
  pricing: '/pricing',
  attendance: '/attendance',
  nftAuthen: 'https://nft-authenticity.airight.io/',
  teleBot: 'https://t.me/aiRightAI_prod_bot',
};

export const MENU = [
  {
    key: MENU_KEY.AiRight,
    link: 'https://airight.io/',
    text: 'AI Service',
    target: '_blank',
  },
  {
    key: MENU_KEY.NftAuthen,
    link: MENU_LINK.nftAuthen,
    text: 'Authentication',
    target: '_blank',
  },
];
